import { Dispatch, SetStateAction } from 'react';

const ZOOM_EPSILON = 1e-9;

export const useZoomHandler = (
  setZoom: Dispatch<SetStateAction<number>>,
  handleZoomChange?: (zoom: number) => void,
) => {
  return (offset: number) => {
    setZoom((prevZoom) => {
      if (
        prevZoom < 0.1 ||
        (Math.abs(prevZoom - 0.1) < ZOOM_EPSILON && offset < 0)
      ) {
        const newZoom = prevZoom + offset / 5;
        handleZoomChange && handleZoomChange(newZoom);
        return newZoom;
      } else {
        handleZoomChange && handleZoomChange(prevZoom + offset);
        return prevZoom + offset;
      }
    });
  };
};
